import { getProductFromSessionStorage } from "src/utils/storage/auth";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const useValidationSchemas = ({
  type,
  cloudProvider,
}: {
  type: "create" | "update";
  cloudProvider: "AWS" | "OCI";
}) => {
  const { t } = useTranslation();
  const couponCodeSchema = {
    couponCode: Yup.string().optional(),
  };
  const commonRequestSchema = {
    licenseCount: Yup.number().required("필수 항목입니다"),
    payTerm: Yup.string().required("필수 항목입니다"),
    totalPrice: Yup.number().required("필수 항목입니다"),
    serviceUid: Yup.string(),
    billType: Yup.string(),
    billCode: Yup.string(),
    nxacAppUids: Yup.mixed(),
    payDate: Yup.string(),
    companyName: Yup.string().optional(),
    referralId: Yup.string().optional(),
    upc: Yup.string().optional(),
    taxInvoice: Yup.mixed().optional(),
    couponCode: Yup.string()
      .matches(/^[A-Z0-9]*$/, "영문과 숫자만 입력할 수 있습니다.")
      .max(20, "최대 20자까지 입력할 수 있습니다."),
  };
  // 현금결제 요청
  const requestCashSchema = {
    ...commonRequestSchema,
    depositor: Yup.string().required("필수 항목입니다"),
  };
  // 카드결제 요청 (INICIS)
  const requestCardSchema = {
    ...commonRequestSchema,
  };
  if (
    cloudProvider === "OCI" &&
    getProductFromSessionStorage() === "WRAPSODY"
  ) {
    // 업데이트 시 일부 필수 아님 처리 가능
    // requestCashSchema.couponCode = Yup.string().optional();
    requestCashSchema.companyName = Yup.string()
      .max(50)
      .required(t("logIn.enterCompanyName"));
    requestCardSchema.companyName = Yup.string()
      .max(50)
      .required(t("logIn.enterCompanyName"));
  }

  return {
    requestCashSchema: Yup.object().shape(requestCashSchema),
    requestCardSchema: Yup.object().shape(requestCardSchema),
  };
};

export default useValidationSchemas;
